//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'NotificationCard',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    sessionData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      totalSeconds: 0,
      timer: null,
      isMinimized: false, 
      position: { left: 0, top: 0 },
      dragging: false,
      dontRemindToday: false
    };
  },
  computed: {
    lastCasePicture() {
      const cases = this.sessionData.cases;
      if (cases && cases.length > 0) return cases[cases.length - 1].picture;
      return '';
    },
    displayCurrent() {
      return Number(this.sessionData.currAmount || 0).toFixed(2);
    },
    displayTotal() {
      return Number(this.sessionData.price || 0).toFixed(2);
    },
    progressPercentage() {
      const total = this.sessionData.price || 0;
      const current = this.sessionData.currAmount || 0;
      if (total === 0) return 0;
      return Math.min((current / total) * 100, 100);
    },
    formattedTime() {
      if (this.totalSeconds <= 0) return '00:00:00';
      const hrs = Math.floor(this.totalSeconds / 3600);
      const mins = Math.floor((this.totalSeconds % 3600) / 60);
      const secs = this.totalSeconds % 60;
      return [
        hrs.toString().padStart(2, '0'),
        mins.toString().padStart(2, '0'),
        secs.toString().padStart(2, '0')
      ].join(':');
    },
    isMobile() {
      return this.$screen?.mobile;
    }
  },
  watch: {
    'sessionData.endTime': {
      handler(newEndTime) {
        this.initCountdown(newEndTime);
      },
      immediate: true
    }
  },
  created() {
    if (this.checkIfMutedToday()) {
      this.$emit('update:visible', false);
      this.$emit('close');
    } else {
      this.initPosition();
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.clearTimer();
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initPosition() {
      const isMobile = this.isMobile;
      // 【修改】移动端默认宽度改为 260px，不再占用过多屏幕空间
      const cardWidth = isMobile ? 260 : 320;
      const cardHeight = isMobile ? 170 : 220;

      this.position = {
        left: isMobile ? (window.innerWidth - cardWidth) / 2 : window.innerWidth - cardWidth,
        top: window.innerHeight - cardHeight
      };
    },
    initCountdown(endTime) {
      this.clearTimer();
      if (!endTime) return;
      const targetTime = new Date(endTime.replace(/-/g, '/')).getTime();
      const now = new Date().getTime();
      this.totalSeconds = Math.max(0, Math.floor((targetTime - now) / 1000));
      if (this.totalSeconds > 0) this.startCountdown();
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.totalSeconds--;
        } else {
          this.clearTimer();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleJoin() {
      this.$emit('join', this.sessionData.id);
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
      this.$nextTick(() => this.handleResize());
    },
    handleClose() {
      if (this.dontRemindToday) {
        this.setMuteToday();
      }
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    setMuteToday() {
      const todayStr = new Date().toDateString();
      localStorage.setItem('mute_notification_date', todayStr);
    },
    checkIfMutedToday() {
      const muteDate = localStorage.getItem('mute_notification_date');
      const todayStr = new Date().toDateString();
      return muteDate === todayStr;
    },
    startDrag(e) {
      if (e.target.closest('.window-controls') || e.target.closest('.no-remind-label')) return;

      this.dragging = true;
      const isTouchEvent = e.type === 'touchstart';
      
      const clientX = isTouchEvent ? e.touches[0].clientX : e.clientX;
      const clientY = isTouchEvent ? e.touches[0].clientY : e.clientY;

      const shiftX = clientX - this.position.left;
      const shiftY = clientY - this.position.top;

      const onMouseMove = (moveEvent) => {
        if (!this.dragging) return;
        
        const currentX = moveEvent.type === 'touchmove' ? moveEvent.touches[0].clientX : moveEvent.clientX;
        const currentY = moveEvent.type === 'touchmove' ? moveEvent.touches[0].clientY : moveEvent.clientY;

        let newLeft = currentX - shiftX;
        let newTop = currentY - shiftY;

        const currentCardWidth = this.isMinimized ? 150 : (this.isMobile ? 260 : 320);
        const currentCardHeight = this.isMinimized ? 38 : (this.isMobile ? 170 : 220);

        const maxLeft = window.innerWidth - currentCardWidth; 
        const maxTop = window.innerHeight - currentCardHeight;

        newLeft = Math.max(5, Math.min(newLeft, maxLeft - 5));
        newTop = Math.max(5, Math.min(newTop, maxTop - 5));

        this.position.left = newLeft;
        this.position.top = newTop;

        if (moveEvent.type === 'touchmove' && moveEvent.cancelable) {
          moveEvent.preventDefault();
        }
      };

      const onMouseUp = () => {
        this.dragging = false;
        if (isTouchEvent) {
          document.removeEventListener('touchmove', onMouseMove);
          document.removeEventListener('touchend', onMouseUp);
        } else {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        }
      };

      if (isTouchEvent) {
        document.addEventListener('touchmove', onMouseMove, { passive: false });
        document.addEventListener('touchend', onMouseUp);
      } else {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      }
    },
    handleResize() {
      const currentCardWidth = this.isMinimized ? 150 : (this.isMobile ? 260 : 320);
      const maxLeft = window.innerWidth - currentCardWidth - 10;
      if (this.position.left > maxLeft) {
        this.position.left = Math.max(5, maxLeft);
      }
    }
  }
};
